import { AddStoreItemType } from 'models/store-item.model';
import { createContext, useContext } from 'react';
import { StoreItemType } from 'models/store-item.model';
import { ActiveType } from 'models/vendors.model';

export type InventoryStoreContextType = {
  storeItemArray: AddStoreItemType[];
  setStoreItemArray: (storeItemArray: AddStoreItemType[]) => void;
  storeItemsToEdit: StoreItemType[];
  setStoreItemsToEdit: (item: StoreItemType[]) => void;
  active: ActiveType | null;
  setActive: (item: ActiveType | null) => void;
  step: number;
  setStep: (value: number) => void;
};

export const InventoryStoreContext = createContext({} as InventoryStoreContextType);
const useInventoryStoreContext = () => {
  const context = useContext(InventoryStoreContext);
  return context;
};

export default useInventoryStoreContext;
